import { Link, useLocation } from "react-router-dom";
import { useClickOutside } from "@mantine/hooks";
import styles from "./styles/Menu.module.scss";
// Common components
import Button from "../../../common/others/Button";
// Utils
import icons from "../../../../utils/icons";
import images from "../../../../utils/images";
import navbarMenuConfigs from "../../../../utils/configs/navbar-menu";
import products from "../../../../assets/temp/fake-data/products";

const Menu = ({ slideMenuDisplayStatue, toggle }) => {
  // Hooks
  const { pathname } = useLocation();
  // Refs, conditions and variables
  const ref = useClickOutside(() => toggle(false));
  const renderLinks = pathname !== "/markets";
  const containerClassName = `${styles.menu} ${
    slideMenuDisplayStatue ? styles.open : ""
  }`;

  return (
    <div className={containerClassName} ref={ref}>
      <Link to={"/"} className={styles.logo}>
        <img alt={"Site logo"} src={images.siteLogo} />
      </Link>
      <Button onClick={() => toggle(false)}>{icons.cross}</Button>

      {renderLinks && (
        <>
          <div className={styles.markets}>
            <Link to={"/markets"} className={styles["main-link"]}>
              بازارها
            </Link>
            <div className={styles["markets-dropdown"]}>
              {products.map((item) => (
                <Link key={item.title} to={"/markets/1"}>
                  {item.title}
                </Link>
              ))}
            </div>
          </div>

          {navbarMenuConfigs.map((item) => (
            <Link
              key={item.title}
              to={item.link}
              className={styles["main-link"]}
            >
              {item.title}
            </Link>
          ))}
        </>
      )}
    </div>
  );
};

export default Menu;
